import StickyAtcBar from '@/components/StickyAtcBar/StickyAtcBar.vue';
import { mountCoreVueApp } from '@/entrypoints/helpers/core-vue-app';

import { initChatbotNudge } from './chatbot-nudge';

export const initStickyAtcBar = async (mountId: string) => {
  if (!document.getElementById(mountId)) {
    return;
  }

  await mountCoreVueApp(StickyAtcBar, `#${mountId}`, {}, null, {
    noClients: true
  });

  initChatbotNudge(mountId);
};
